// find all characters that are after &go=. This is URL param that contains target url added in smartadserver and can contain nested query params. We decode the uri first as some urls may income encoded
export const encodeTargetUrl = (smartAdServerURL: string | undefined) => {
    // Cases where no url was provided to smart ad server script
    if (!smartAdServerURL) {
        return "";
    }

    // query param in which the whole provided advert url is added
    const QUERY_PARAM = "&go=";
    const queryParamIndex = smartAdServerURL.indexOf(QUERY_PARAM);

    // Guard for cases where no query param was found
    if (queryParamIndex < 0) {
        return smartAdServerURL;
    }

    const smartAdServerUrlChunk = smartAdServerURL.slice(0, queryParamIndex + QUERY_PARAM.length);
    const advertUrlChunk = smartAdServerURL.slice(queryParamIndex + QUERY_PARAM.length);

    return smartAdServerUrlChunk + encodeURIComponent(decodeURIComponent(advertUrlChunk));
};
